<h2 [innerHTML]="'text_buyNowDialog.header' | dbText"></h2>
<p [innerHTML]="'text_buyNowDialog.message' | dbText"></p>
<button class="ds-btn-blue" (click)="chosePlan()">
  <span [innerHTML]="'text_buyNowDialog.text' | dbText"></span>
</button>
